export default class Funcionario {
  constructor(
    id = null,
    cargoPrincipal = '',
    siglaUnidadeOrganizacional = '',
    unidadeOrganizacional = '',
    dataInicioAtividade = null,
    dataFimAtividade = null,
    tipo = '',
    centroCustoFormatado = '',
    registroFormatado = '',
    uorId = null,
    perfis = [],
    cpf = '',
    idPessoaFisica = null,
    nome = '',
  ) {
    this.id = id;
    this.cargoPrincipal = cargoPrincipal;
    this.siglaUnidadeOrganizacional = siglaUnidadeOrganizacional;
    this.unidadeOrganizacional = unidadeOrganizacional;
    this.dataInicioAtividade = dataInicioAtividade;
    this.dataFimAtividade = dataFimAtividade;
    this.tipo = tipo;
    this.centroCustoFormatado = centroCustoFormatado;
    this.registroFormatado = registroFormatado;
    this.uorId = uorId;
    this.perfis = perfis;
    this.cpf = cpf;
    this.idPessoaFisica = idPessoaFisica;
    this.nome = nome;
  }
}



// WEBPACK FOOTER //
// ./src/domain/funcionario/index.js